export const Auth = {
  signOut: async () => undefined,
};

export default Auth;
